(function(root) {
  'use strict';

  var SAFE_INSET = 0.78;
  var CANVAS_SIZE = 320;

  function getStageAvailableSize() {
    var el = document.getElementById('zug-stage');
    if (!el) return { w: 320, h: 320 };
    var rect = el.getBoundingClientRect();
    return {
      w: Math.floor(rect.width),
      h: Math.floor(rect.height)
    };
  }

  function getStageAvailableWidth() {
    return getStageAvailableSize().w;
  }

  function getAspectMaskDims(printW, printH) {
    var aspect = (printW && printH && printH > 0) ? (printW / printH) : 1;
    var maskW;
    var maskH;
    if (aspect >= 1) {
      maskW = SAFE_INSET;
      maskH = SAFE_INSET / aspect;
    } else {
      maskH = SAFE_INSET;
      maskW = SAFE_INSET * aspect;
    }
    return { w: maskW, h: maskH, aspect: aspect };
  }

  function computeCornerRadiusNorm(radiusInches, maskW, maskH, printW, printH) {
    maskW = maskW || SAFE_INSET;
    maskH = maskH || SAFE_INSET;
    if (!printW || !printH || printW <= 0 || printH <= 0) return 0.04;
    var rxNorm = radiusInches * Math.min(maskW / printW, maskH / printH);
    rxNorm = Math.max(0, Math.min(rxNorm, Math.min(maskW, maskH) / 2));
    return rxNorm;
  }

  function buildPlacementConfig(shapeMode, printW, printH, cornerRadiusIn) {
    var dims = getAspectMaskDims(printW, printH);
    var maskX = (1 - dims.w) / 2;
    var maskY = (1 - dims.h) / 2;
    var mask;

    if (shapeMode === 'round' || shapeMode === 'oval') {
      mask = { type: 'ellipse', cx: 0.5, cy: 0.5, rx: dims.w / 2, ry: dims.h / 2 };
    } else if (shapeMode === 'square' || shapeMode === 'rectangle') {
      mask = { type: 'rect', x: maskX, y: maskY, w: dims.w, h: dims.h, rx: 0, ry: 0 };
    } else if (shapeMode === 'rounded') {
      var rxNorm = computeCornerRadiusNorm(cornerRadiusIn || 0.25, dims.w, dims.h, printW, printH);
      mask = { type: 'rounded-rect', x: maskX, y: maskY, w: dims.w, h: dims.h, rx: rxNorm, ry: rxNorm };
    } else {
      return null;
    }

    return {
      canvas: { width: CANVAS_SIZE, height: CANVAS_SIZE },
      mask: mask,
      bleed: 0,
      defaultMode: 'fit',
      enforceCoverage: false
    };
  }

  function isValidHexColor(str) {
    if (typeof str !== 'string') return false;
    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(str);
  }

  function getCutlineStrokeColor(apiColor) {
    var override = root.ZUG_CUTLINE_COLOR_OVERRIDE;
    if (isValidHexColor(override)) return override;
    if (isValidHexColor(apiColor)) return apiColor;
    return '#00A2F9';
  }

  function getCutlineStrokeWidth(apiWidth) {
    var fallback = 2.0;
    var overrideEnabled = root.ZUG_CUTLINE_WIDTH_OVERRIDE_ENABLED;
    var overrideValue = parseFloat(root.ZUG_CUTLINE_WIDTH_OVERRIDE);
    if (overrideEnabled && !isNaN(overrideValue) && overrideValue > 0) {
      return overrideValue;
    }
    var apiValue = parseFloat(apiWidth);
    if (!isNaN(apiValue) && apiValue > 0) {
      return apiValue;
    }
    return fallback;
  }

  root.ZugUploadModalUtils = {
    buildPlacementConfig: buildPlacementConfig,
    computeCornerRadiusNorm: computeCornerRadiusNorm,
    getAspectMaskDims: getAspectMaskDims,
    getCutlineStrokeColor: getCutlineStrokeColor,
    getCutlineStrokeWidth: getCutlineStrokeWidth,
    getStageAvailableSize: getStageAvailableSize,
    getStageAvailableWidth: getStageAvailableWidth,
    isValidHexColor: isValidHexColor
  };
})(typeof window !== 'undefined' ? window : globalThis);
